import { render } from "./MenuCategories.vue?vue&type=template&id=d9eeff1e&ts=true"
import script from "./MenuCategories.vue?vue&type=script&lang=ts"
export * from "./MenuCategories.vue?vue&type=script&lang=ts"

import "./MenuCategories.vue?vue&type=style&index=0&id=d9eeff1e&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__